export function useDesign(scope: string) {
  const prefix = 'tkc';
  return {
    // prefixCls: computed(() => `${values.prefixCls}-${scope}`),
    prefixCls: `${prefix}-${scope}`,
    prefixVar: prefix,
  };
}
